module.exports = require("react-native-css-interop/jsx-runtime");
